<template>
  <div class="app-container">
    <navigation title="个人信息"></navigation>
    <van-form @submit="onSubmit">
      <van-cell-group>
        <van-cell title="账号" value="">
          <template #label>
            <van-field v-model="userInfo.uid" label="" placeholder="请输入用户名" name="uid" readonly/>
          </template>
        </van-cell>
        <van-cell title="性别">
          <template #label>
            <van-field v-model="userInfo.sex" label="" name="sex">
              <template #input>
                <van-radio-group v-model="radio" direction="horizontal" name="sex">
                  <van-radio name="男" checked-color="#008095">男</van-radio>
                  <van-radio name="女" checked-color="#008095">女</van-radio>
                </van-radio-group>
              </template>
            </van-field>
          </template>
        </van-cell>
        <van-cell title="真实姓名" value="">
          <template #label>
            <van-tag v-if="userInfo.cn" color="#fff" text-color="#07c160">已实名认证</van-tag>
            <van-tag v-else color="#fff" text-color="#ee0a24" @click="onCertification">去认证</van-tag>
          </template>
        </van-cell>
        <van-popup v-model="dialogShow"  :style="{width:'5.98rem',borderRadius:'16px',paddingTop:'.1rem'}">
          <van-cell title="实名认证" :style="{fontSize:'.36rem'}" class="dia-title">
            <template #right-icon>
              <van-icon name="close" color="#008095" size="25" @click="onCloseDialog"/>
            </template>
          </van-cell>
          <van-form @submit="onCertificationSubmit" class="certification">
            <van-field
              v-model="userInfo.cn"
              name="cn"
              label="姓名"
              placeholder="请输入真实姓名"
              colon
              :rules="[{ required: true, message: '请填写姓名' }]"
              label-width="50px"
            />
            <van-field
              v-model="userInfo.idno"
              name="idno"
              label="身份证"
              placeholder="请输入身份证号"
              colon
              :rules="idno"
              label-width="50px"
              maxlength="18"
            />
            <div style="margin:16px 16px 16px 0;">
              <van-button round block type="info" native-type="submit" color="#008095">认证</van-button>
            </div>
          </van-form>
        </van-popup>
        <van-cell title="出生日期" @click="showPicker = true">
          <template #label>
            <van-field
              readonly
              clickable
              name="birthday"
              :value="date"
              placeholder="点击选择日期"
              @click="showPicker = true"
            />
          </template>
        </van-cell>
        <van-popup v-model="showPicker" position="bottom">
          <van-datetime-picker
            v-model="userInfo.birthday"
            type="date"
            @confirm="onConfirm"
            title="选择年月日"
            @cancel="showPicker = false"
            :min-date="minDate"
            :max-date="maxDate"
          />
        </van-popup>
        <van-cell title="邮箱" value="">
          <template #label>
            <van-field v-model="userInfo.mail" placeholder="请输入邮箱" name="mail" :rules="mail"/>
          </template>
        </van-cell>
        <van-cell title="手机号" value="">
          <template #label>
            <van-field v-model="userInfo.mobile" placeholder="请输入手机号" name="mobile" :rules="mobile"/>
          </template>
        </van-cell>
        <van-cell title="国家" value="">
          <template #label>
            <van-field v-model="userInfo.country" placeholder="请输入国家" name="country"/>
          </template>
        </van-cell>
        <van-cell title="学历" value="">
          <template #label>
            <van-field v-model="userInfo.education" placeholder="请输入学历" name="education"/>
          </template>
        </van-cell>
        <van-cell title="职称" value="">
          <template #label>
            <van-field v-model="userInfo.titleAttr" placeholder="请输入您的职称" name="titleAttr"/>
          </template>
        </van-cell>
        <van-cell title="邮政地址" value="">
          <template #label>
            <van-field v-model="userInfo.postalAddress" placeholder="请输入邮政地址信息" name="postalAddress"/>
          </template>
        </van-cell>
        <van-cell title="邮编" value="">
          <template #label>
            <van-field v-model="userInfo.postalCode" placeholder="请填写所在地邮编" name="postalCode"/>
          </template>
        </van-cell>
        <van-cell title="固定电话" value="">
          <template #label>
            <van-field v-model="userInfo.fixphone" placeholder="请填写固定电话" name="fixphone"/>
          </template>
        </van-cell>
        <van-cell title="传真" value="">
          <template #label>
            <van-field v-model="userInfo.faxno" placeholder="请填写传真信息" name="faxno"/>
          </template>
        </van-cell>
      </van-cell-group>
      <van-popup v-model="dialogPassword"  :style="{width:'5.98rem',borderRadius:'16px',paddingTop:'.1rem'}">
        <van-cell title="请输入账号密码" :style="{fontSize:'.36rem'}" class="dia-title">
          <template #right-icon>
            <van-icon name="close" color="#008095" size="25" @click="onCloseDialog"/>
          </template>
        </van-cell>
        <van-field type="password" v-model="password" label="密码" placeholder="请填写密码" name="password" class="password"
                   :rules="[{ required: true, message: '请填写密码' }]"/>
        <div style="margin: 16px">
          <van-button round block type="info" color="#008095" @click="passwordSub">确定</van-button>
        </div>
      </van-popup>
      <div style="margin: 16px;">
        <van-button round block type="info" native-type="submit" color="#008095">保存</van-button>
      </div>
    </van-form>
    <version></version>
  </div>
</template>

<script>
import Vue from 'vue'
import { NavBar, Cell, CellGroup, RadioGroup, Radio, DatetimePicker, Popup, Form, Button, Tag, Field, Icon, Toast } from 'vant'
import {request} from '../../untils/request'
import navigation from '../../components/navigation'
import version from '../../components/version'

Vue.use(NavBar).use(Cell).use(CellGroup).use(RadioGroup).use(Radio).use(DatetimePicker).use(Popup).use(Form).use(Icon)
  .use(Button).use(Tag).use(Field).use(Toast)

export default {
  name: 'personalInformation',
  components: {navigation, version},
  data () {
    return {
      radio: '1',
      showPicker: false,
      date: '请选择出生日期',
      currentDate: new Date(2021, 0, 1),
      minDate: new Date(1960, 0, 1),
      maxDate: new Date(2021, 10, 1),
      dialogShow: false,
      dialogPassword: false,
      userInfo: {},
      password: '',
      idno: [{
        // 自定义校验规则
        validator: value => {
          return /^(^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$)|(^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])((\d{4})|\d{3}[Xx])$)$/
            .test(value)
        },
        message: '请输入正确的身份证号',
        trigger: 'onBlur'
      }],
      mail: [{
        validator: value => {
          if (value) {
            return /^[a-zA-Z0-9]+([-_.][a-zA-Z0-9]+)*@[a-zA-Z0-9]+([-_.][a-zA-Z0-9]+)*\.[a-z]{2,}$/
              .test(value)
          }
        },
        message: '请输入正确的邮箱',
        trigger: 'onBlur'
      }],
      mobile: [{
        validator: value => {
          if (value) {
            return /^1[3456789]\d{9}$/
              .test(value)
          }
        },
        message: '请输入正确的手机号',
        trigger: 'onBlur'
      }]
    }
  },
  created () {
    window.scroll(0, 0)
    // 用户信息
    this.getUser()
  },
  methods: {
    getUser () {
      request('post', '/nlc-api/api/nlc/userInfo', {}).then(res => {
        console.log('用户信息', res)
        this.userInfo = res.data.user
      })
    },
    formatDate (date) {
      return `${date.getFullYear()}/${date.getMonth() + 1}/${date.getDate()}`
    },
    // 选择日期
    onConfirm (date) {
      console.log('time', date)
      this.date = this.formatDate(date)
      console.log('this.value', this.date)
      this.showPicker = false
    },
    // 提交
    onSubmit (values) {
      console.log('submit', values)
      console.log('this.password', this.password)
      if (this.password) {
        var user = {
          uid: this.userInfo.uid,
          password: this.password
        }
        var params = Object.assign(user, values)
        console.log('params', params)
        request('post', '/nlc-api/api/nlc/updateNlcUser', params).then(res => {
          console.log('提交', res)
          if (res.code === '1004') {
            Toast.fail('密码错误')
          } else if (res.code === '200') {
            Toast.success('提交成功')
          }
        })
      } else {
        this.dialogPassword = true
      }
    },
    // 返回
    onClickLeft () {
      this.$router.go(-1)
    },
    // 认证弹框认证弹框
    onCertification () {
      this.dialogShow = true
    },
    // 关闭弹框
    onCloseDialog () {
      this.dialogShow = false
      this.dialogPassword = false
    },
    // 认证
    onCertificationSubmit (values) {
      console.log('values', values)
      if (this.password) {
        var user = {
          uid: this.userInfo.uid,
          password: this.password
        }
        var params = Object.assign(user, values)
        console.log('params', params)
        request('post', '/nlc-api/api/nlc/realNameAuthentication', params).then(res => {
          console.log('认证', res)
          if (res.code === '200') {
            Toast.success('认证成功')
          } else {
            Toast.fail('认证失败')
          }
        })
      } else {
        this.dialogPassword = true
      }
    },
    // 密码确认
    passwordSub () {
      if (this.password) {
        this.dialogPassword = false
      }
    }
  }
}
</script>

<style scoped>
.app-container{
  overflow-y:scroll;
}
.van-form{
  margin-top:.92rem;
}
input{
  border:none;
  font-family: SourceHanSansCN-Light;
}
.tip{
  color:#C9CBCD;
  text-align:center;
  font-size:.2rem;
  padding: 0 0 .25rem 0;
  line-height:.2rem;
  font-family: SourceHanSansCN-Light;
}
.van-tag{
  padding:0 !important;
}
.van-cell__title{
  font-family: SourceHanSansCN-Regular;

}
.van-radio__label,.van-tag{
  font-family: SourceHanSansCN-Light;
}
.van-button{
  font-family: SourceHanSerifCN-Bold;
  font-size:.36rem;
}
.dia-title .van-cell__title{
  font-family: SourceHanSerifCN-SemiBold;
}
.dia-title::after{
  border:0 !important;
}
.van-field__label{
  font-family: SourceHanSansCN-Regular;
}
.van-field__control{
  font-family: SourceHanSansCN-Light;
  font-size:.24rem !important;
  width:80% !important;
}
.van-field{
  padding:0 !important;
  width:90%
}
.certification{
  margin-left:.4rem;
  margin-top:0;
}
.certification .van-field{
  line-height:.8rem;
}
.password{
  width:85%;
  margin:0 .4rem;
  line-height:.8rem;
}
</style>



// WEBPACK FOOTER //
// src/view/personalInformation/index.vue